import PropTypes from "prop-types";
import React from "react";

const DropdownField = ({ name, options, onChange, placeHolder, value }) => {
  return (
    <select
      className="form-control"
      name={name}
      value={value}
      onChange={onChange}
    >
      {placeHolder !== 'All Specialities' && (
        <option value="">{placeHolder}</option>
      )}
      {options &&
        options.length > 0 &&
        options.map((option) => (
          <option key={option.id} value={option.id}>
            {option.name}
          </option>
        ))}
    </select>
  );
};

DropdownField.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  placeHolder: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default DropdownField;
